import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import FeatureItem from 'modules/upsell/components/UpsellModalModulesConfirmation/_FeatureItem'

interface SharableSessionBodyProps {
  onClick: () => void
  moduleName?: string
  sharedSessionTitle?: string
}

const SharableSessionBody = ({
  moduleName,
  sharedSessionTitle,
  onClick,
}: SharableSessionBodyProps) => {
  return (
    <Box>
      <Box
        padding="s16"
        gap="s4"
        border={{
          bottom: {
            color: 'grey200',
            style: 'solid',
            width: 's1',
          },
        }}
      >
        <Text.Normal size="100" color="grey600" weight="bold" caps>
          {i18n.t('upsell.request_modal.confirmation.shared_sessions.subtitle')} - {moduleName}
        </Text.Normal>
        <Text.Normal size="300" color="grey1000" weight="bold">
          {sharedSessionTitle}
        </Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="spaceBetween" padding="s16" alignItems="center">
        <Text.Normal size="200" color="grey700" weight="normal">
          {i18n.t('upsell.request_modal.confirmation.shared_sessions.footer')}
        </Text.Normal>
        <F0Button
          onClick={onClick}
          label={i18n.t('upsell.request_modal.confirmation.shared_sessions.button')}
        />
      </Box>
    </Box>
  )
}

interface ModalBodyProps {
  features: string[]
  onClick: () => void
  sharedSession: {
    showSharedSession: boolean
    moduleName?: string
    sharedSessionLink?: string
    sharedSessionTitle?: string
  }
}

const ModalBody = ({ features, sharedSession, onClick }: ModalBodyProps) => {
  const { showSharedSession, sharedSessionTitle, moduleName } = sharedSession

  return (
    <Box
      width="full"
      gap="s24"
      background="grey000White"
      borderRadius={{
        all: 'abs016',
      }}
      border={{
        all: {
          color: 'grey200',
          style: 'solid',
          width: 's1',
        },
      }}
    >
      <>
        {showSharedSession ? (
          <SharableSessionBody
            onClick={onClick}
            sharedSessionTitle={sharedSessionTitle}
            moduleName={moduleName}
          />
        ) : (
          <Box padding="s16" gap="s12">
            <Box>
              <Text.Normal size="100" color="grey600" weight="bold" caps>
                {i18n.t('upsell.request_modal.confirmation.features_title')}
              </Text.Normal>
            </Box>
            {features.map((text, index) => (
              <FeatureItem key={index} text={text} isActive={index === 0} />
            ))}
          </Box>
        )}
      </>
    </Box>
  )
}

export default ModalBody
